import BaseSlider from '@components/base/BaseSlider';

export default BaseSlider;
